import { useCallback } from 'react';
import { ComputeUnits } from 'src/@types/types';
import usePriorityFeeStore from 'src/stores/usePriorityFeeStore';
import { getTxParams } from 'src/utils/transaction';
import { MarketId } from '@drift/common';

export type GetTxParamsProps = {
	computeUnits?: ComputeUnits;
	useSimulatedComputeUnits?: boolean;
	simulatedComputeUnitMultiplier?: number;
	marketId?: MarketId;
	lowerBoundCu?: number;
};

export const useGetTxParams = () => {
	const getPriorityFeeToUse = usePriorityFeeStore((s) => s.getPriorityFeeToUse);

	return useCallback(
		(props?: {
			computeUnits?: ComputeUnits;
			useSimulatedComputeUnits?: boolean;
			simulatedComputeUnitMultiplier?: number;
			marketId?: MarketId;
			lowerBoundCu?: number;
		}) => {
			const computeUnits = props?.computeUnits ?? (600_000 as ComputeUnits);
			const useSimulatedComputeUnits = props?.useSimulatedComputeUnits;
			const simulatedComputeUnitMultiplier =
				props?.simulatedComputeUnitMultiplier;
			const marketId = props?.marketId;
			const lowerBoundCu = props?.lowerBoundCu;

			return getTxParams(
				(computeUnits) =>
					getPriorityFeeToUse(undefined, computeUnits, marketId),
				computeUnits,
				getPriorityFeeToUse(undefined, computeUnits, marketId),
				useSimulatedComputeUnits,
				simulatedComputeUnitMultiplier,
				lowerBoundCu
			);
		},
		[getPriorityFeeToUse]
	);
};
